import { useEffect } from 'react';
import { useHistoryWithHost } from 'routes/useHistoryWithHost';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';

import { ReactComponent as CheckIcon } from 'assets/images/checkIcon.svg';
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalFooter,
} from '@grupoboticario/flora-react';

import { clearAllSteps } from 'store/modules/openClaim/actions';
import { ButtonSpaceG } from '../../sharedStyles';
import { ModalText, ButtonFooter } from './styles';

interface IModalSaveDraft {
  stateModal: {
    display: number;
    errorMessage: string;
  };
  setStateModal: any;
  setIsOpen: any;
  isOpen: boolean;
  idTimeline: string;
}

export const ModalEndDraft = (props: IModalSaveDraft): JSX.Element => {
  const { setIsOpen, isOpen, stateModal, setStateModal, idTimeline } = props;

  const stateFinalId = useSelector(
    (state: ApplicationState) => state.openClaim.finalId,
  );

  const history = useHistoryWithHost();
  const dispatch = useDispatch();

  const navigateToHome = (openTimeline: boolean) => {
    setIsOpen(false);
    dispatch(clearAllSteps());
    if (openTimeline) {
      history.push('/', { id: idTimeline });
    } else {
      history.push('/');
    }
  };

  const closeModal = () => {
    if (stateModal.display === 1) {
      history.push('/');
    }
    setIsOpen(false);
    setStateModal({ ...stateModal, display: 1 });
  };

  useEffect(() => {}, [stateModal]);

  return (
    <Modal open={isOpen} onOpenChange={closeModal}>
      <ModalContent size="small">
        <ModalCloseButton />
        <ModalHeader />
        {stateModal.display === 1 && (
          <>
            <ModalBody>
              <ModalText>
                <CheckIcon />
                <p>Sinistro aberto com sucesso!</p>
                <span>Seu código: {stateFinalId}</span>
                <p>Seus dados e documentos foram enviados para análise.</p>
                <p>
                  Você receberá avisos no status deste processo, fique de olho!
                </p>
              </ModalText>
            </ModalBody>
            <ButtonFooter>
              <ButtonSpaceG
                styleSemantic="success"
                size="small"
                onClick={() => navigateToHome(false)}
              >
                Ok
              </ButtonSpaceG>
              <ButtonSpaceG size="small" onClick={() => navigateToHome(true)}>
                Acompanhar
              </ButtonSpaceG>
            </ButtonFooter>
          </>
        )}
        {stateModal.display === 2 && (
          <>
            <ModalBody>
              <ModalText>
                <p>Erro ao abrir o sinistro.</p>
                <p>Tente novamente mais tarde.</p>
              </ModalText>
            </ModalBody>
            <ButtonFooter>
              <ButtonSpaceG size="small" onClick={() => closeModal()}>
                Ok
              </ButtonSpaceG>
            </ButtonFooter>
          </>
        )}
        {stateModal.display === 3 && (
          <>
            <ModalBody>
              <ModalText>
                <p>Erro ao abrir o sinistro.</p>
                <p>
                  Atualize o Prejuízo Estimado na sessão de Dados da ocorrência.
                </p>
              </ModalText>
            </ModalBody>
            <ButtonFooter>
              <ButtonSpaceG size="small" onClick={() => closeModal()}>
                Ok
              </ButtonSpaceG>
            </ButtonFooter>
          </>
        )}
        <ModalFooter />
      </ModalContent>
    </Modal>
  );
};
